import {
    type BlastForecastClientInterface,
    type GetBlastForecastRequest,
    axiosCacheInterceptorRequestConfig,
} from './blastForecastClient.types';
import BaseClient, { type BaseClientConfig } from '../BaseClient';

export default class OrgUnitBlastForecastClient extends BaseClient implements BlastForecastClientInterface {
    constructor(private teamId: number, private orgUnitId: number, config: BaseClientConfig = {}) {
        super(config);
    }

    getBlastForecastSummary(params: GetBlastForecastRequest) {
        const url = `/api/v3/teams/${this.teamId}/org-units/${this.orgUnitId}/blast-forecast/summary`;
        return this.makeCoreApiRequest(url, 'post', params, null, axiosCacheInterceptorRequestConfig);
    }

    getBlastForecastCampaigns(params: GetBlastForecastRequest) {
        const url = `/api/v3/teams/${this.teamId}/org-units/${this.orgUnitId}/blast-forecast/campaigns`;
        return this.makeCoreApiRequest(url, 'post', params, null, axiosCacheInterceptorRequestConfig);
    }
}
